import React, { useMemo, useContext } from "react";
import Select from "react-select";
import CustomSelect from "./CustomSelect";
import { DataContext } from "../context/DataContext";
import {
  YEAR_OPTIONS,
  INITIAL_YEAR_OPTION,
  YEAR_BUTTON_SCHEMA,
} from "../utils/constants";
import ButtonBar from "./ButtonBar";
import Radio from "./Radio";

const createGroupedOptions = (countyData, judgesData) => {
  return [
    {
      label: "Counties",
      options: countyData,
    },
    {
      label: "Judges",
      options: judgesData,
    },
  ];
};

const Filters = () => {
  const {
    countyData,
    judgesData,
    selection,
    changeSelection,
    year,
    changeYear,
  } = useContext(DataContext);
  const cleanSelectedOption = useMemo(
    () => ({ value: selection.id, label: selection.label }),
    [selection]
  );
  const options = useMemo(() => createGroupedOptions(countyData, judgesData), [
    countyData,
    judgesData,
  ]);

  return (
    <div className="filters__container">
      <div className="filters__filter-container year">
        <div className="filters__filter-label">Year:</div>
        <Radio
          schema={YEAR_BUTTON_SCHEMA}
          active={year}
          handleChange={changeYear}
        />
      </div>

      <div className="filters__filter-container search">
        <CustomSelect
          className="filters__input"
          closeMenuOnSelect
          value={cleanSelectedOption}
          isDisabled={false}
          isLoading={false}
          isClearable
          backspaceRemovesValue
          isSearchable
          name="search"
          options={options}
          onChange={changeSelection}
          placeholder="Search county or judge..."
          maxMenuHeight={170}
        />
      </div>
    </div>
  );
};

export default Filters;

// <div className="filters__filter-container year show-for-non-mobile">
// <Select
//   options={YEAR_OPTIONS}
//   className="filters__input"
//   onChange={(e) => changeYear(e.value)}
//   defaultValue={INITIAL_YEAR_OPTION}
//   isSearchable={false}
// />
// </div>
